import React, { useState } from "react"
import { Grid, Divider } from "@material-ui/core"
import {
  MasterButton,
  InputTextMaster,
  InputCheckboxMaster,
  InputOptionMaster,
  InputReactDatepicker,
} from "App/Component/ui"
import ToggleDetailStatusSyncIHS from "./ToggleDetailStatusSyncIHS"
import { useSelector } from "react-redux"
import { isNull } from "App/utils/helpers"

export default function FormFilterKunjunganRawatJalan({
  formFilter,
  setFormFilter,
  setNewData,
  resetPagination,
}) {
  const [open, setOpen] = useState(false)
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }

    setOpen(open)
  }

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    await setNewData(1, 10)
    resetPagination()
  }

  const master = useSelector(({ master }) => master)

  return (
    <>
      <ToggleDetailStatusSyncIHS toggleDrawer={toggleDrawer} open={open} />
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputTextMaster
              name="id_rm"
              label="ID RM"
              id="id_rm"
              placeholder="ID RM"
              onChange={handleChange("idrm")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="insurance_id"
              label="ASURANSI"
              id="insurance_id"
              withSearch={true}
              data={master.asuransi.list_select}
              value={formFilter.insurance_id}
              labelValue={formFilter.insurance_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    insurance_id: null,
                    insurance_name: "Pilih Asuransi",
                  })
                } else {
                  setFormFilter({
                    ...formFilter,
                    insurance_id: e.value,
                    insurance_name: e.label,
                  })
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="insurance_number"
              label="NO ASURANSI"
              id="insurance_number"
              placeholder="No Asuransi/BPJS"
              value={formFilter.insurance_number}
              onChange={handleChange("insurance_number")}
              error={true}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="nama_rm"
              label="NAMA RM"
              id="nama_rm"
              placeholder="Nama RM"
              onChange={handleChange("namarm")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="nik"
              label="NIK"
              id="nik"
              placeholder="NIK"
              onChange={handleChange("nik")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="alamat"
              label="ALAMAT"
              id="alamat"
              placeholder="Alamat"
              onChange={handleChange("alamat")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              isClearable
              selected={formFilter.tanggal_lahir}
              label="TANGGAL LAHIR"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_lahir: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_lahir: e,
                })
              }
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="status"
              label="STATUS"
              id="status"
              withSearch={false}
              data={[
                {
                  value: 0,
                  label: "Semua",
                },
                {
                  value: 1,
                  label: "Aktif",
                },
                {
                  value: 2,
                  label: "Tidak Aktif",
                },
              ]}
              value={formFilter.status}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  status: e.target.value,
                })
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.tanggal_awal}
              label="TANGGAL AWAL"
              dateFormat="dd/MM/yyyy"
              isClearable
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                })
              }
            />
          </Grid>

          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.tanggal_akhir}
              isClearable
              label="TANGGAL AKHIR"
              dateFormat="dd/MM/yyyy"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="created_name"
              label="INSERTED USER"
              id="created_name"
              placeholder="Username"
              onChange={handleChange("created_name")}
            />
          </Grid>

          <Grid item sm={3}>
            <div className="mt-2">
              <InputCheckboxMaster
                checked={formFilter.external}
                name="external_filter"
                id="external_filter"
                label="External"
                onChange={() =>
                  setFormFilter({
                    ...formFilter,
                    external: !formFilter.external,
                  })
                }
              />
            </div>
          </Grid>
        </Grid>
        <br />

        <div
          className="mt-1"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <MasterButton
            name={"MONITORING SINGKRONISASI BERJALAN"}
            outline={true}
            color={"green"}
            onClick={() => setOpen(true)}
            type="button"
            size={"md"}
          />
          <MasterButton
            name={"CARI"}
            type="submit"
            outline={true}
            color={"green"}
            size={"md"}
          />
        </div>

        <br />
        <Divider />
      </form>
    </>
  )
}
